import { action, observable } from 'mobx'

import Datehelper from '../utils/datehelper';
import Ds from './ds'
import moment from 'moment'

class Companies {
  @observable data = []
  @observable companiesByState = []
  @observable notes = []
  @observable noteDetail = {}
  @observable taskDetail = {}
  @observable tasks = []
  @observable partners = []
  @observable orders = []
  @observable quotes = []
  @observable invoices = []
  @observable leads = []
  @observable customers = []
  @observable contacts = []
  @observable inactive = []
  @observable assigned = []
  @observable leadsCount = 0
  @observable customersCount = 0
  @observable inactiveCount = 0
  @observable newlyAssignedLeadsCount = 0
  @observable leadCountByMonth = {}
  @observable sourceLeadCountByDateRange = {}
  @observable leadCountBreakdown = {}
  @observable companyDetailsBySourceByDateRange = {}
  @observable companyDetails = {}
  @observable details = {
    userName: 'Loading...',
    contactFullName: 'Loading...',
    contactTitle: 'Loading...',
    contactEmail: 'Loading...',
    contactPhone: 'Loading...',
    categoryName: 'Loading...',
    industryName: 'Loading...',
    companyState: 'Loading...',
    billingStatus: 'Loading...',
    partnerId: ''
  }
  @observable sources = null
  @observable saveCardResults = null
  @observable stripeCustomerId = ''

  @observable ds = new Ds()

  @action countLeads() {
    let query = `{ countCompaniesByType( organizationId: ${localStorage.getItem('userOrganizationId')}, companyStateId: ${2}, hash: "${localStorage.getItem('userHash')}") }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.leadsCount = data.countCompaniesByType
      return this.leadCount
    })
  }

  @action countCustomers() {
    let query = `{ countCompaniesByType( organizationId: ${localStorage.getItem('userOrganizationId')}, companyStateId: ${3}, hash: "${localStorage.getItem('userHash')}") }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.customersCount = data.countCompaniesByType
      return this.customersCount
    })
  }

  @action countInactive() {
    let query = `{ countCompaniesByType( organizationId: ${localStorage.getItem('userOrganizationId')}, companyStateId: ${4}, hash: "${localStorage.getItem('userHash')}") }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.inactiveCount = data.countCompaniesByType
      return this.inactiveCount
    })
  }

  @action loadLeadCountByMonth(callback) {
    let query = `{ countLeadsByMonth( organizationId: ${localStorage.getItem('userOrganizationId')}, hash: "${localStorage.getItem('userHash')}")  { statusCode data }  }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.leadCountByMonth = data.countLeadsByMonth.data.results

      if (callback) {
        callback(this.leadCountByMonth)
      }

      return this.leadCountByMonth
    })
  }

  @action getSourceLeadCountByDateRange(startDate, endDate, callback) {
    var convertedStartDate = new Date(Date.parse(startDate))
    var formattedStartDate = Datehelper.dateToTimestamp(convertedStartDate)
    
    var convertedEndDate = new Date(Date.parse(endDate))
    convertedEndDate.setDate(convertedEndDate.getDate()+1)
    var formattedEndDate = Datehelper.dateToTimestamp(convertedEndDate)

    let query = `{ getSourceLeadCountByDateRange( start: "${ formattedStartDate }" end: "${ formattedEndDate }" hash: "${ localStorage.getItem('userHash') }") { statusCode data } }`

    console.log(query)

    this.ds.query(query, (data) => {
      console.log('Data: ', data)
      this.sourceLeadCountByDateRange = data.getSourceLeadCountByDateRange.data.results

      if (callback) {
        callback(this.sourceLeadCountByDateRange)
      }

      return this.sourceLeadCountByDateRange
    })
  }

  @action resetSourceLeadCountByDateRange() {
    this.sourceLeadCountByDateRange = {}
  }

  @action getLeadCountBreakdown(startDate, endDate, callback) {
    let query = `{ companiesCreatedAt( hash: "${localStorage.getItem('userHash')}", startDate: "${startDate}", endDate: "${endDate}" ) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source{ name }} }`
    
    console.log(query)

    this.ds.query(query, (data) => { 
      if (data.companiesCreatedAt) {
        this.leadCountBreakdown = data.companiesCreatedAt.map((company) => {
          if (company.defaultContact) {
            company.fullName = company.defaultContact.fullName
            company.email = company.defaultContact.email
            company.phone = company.defaultContact.phone
          } else {
            company.fullName = 'unassigned'
            company.email = 'n/a'
            company.phone = 'n/a'
          }

          if (company.user) {
            company.userFullName = company.user.firstName + ' ' + company.user.lastName
          } else {
            company.userFullName = ''
          }

          if (company.vendor) {
            company.vendorName = company.vendor.name
          } else {
            company.vendorName = 'unassigned'
          }

          if (company.source) {
            company.sourceName = company.source.name
          } else {
            company.sourceName = 'unassigned'
          }

          if (company.defaultBillingAddress) {
            company.address = company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.city + ' ' + company.defaultBillingAddress.state + ' ' + company.defaultBillingAddress.zipCode
          } else {
            company.address = 'n/a'
          }

          return company
        })
      }
      
      if (callback) {
        callback(this.leadCountBreakdown)
      }
    })
  }

  @action getCompanyDetailsBySourceByDateRange(sourceId, startDate, endDate, callback) {
    let query = `{ companiesCreatedAt( hash: "${localStorage.getItem('userHash')}", sourceId: ${sourceId}, startDate: "${startDate}", endDate: "${endDate}" ) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source{ name }} }`
    
    console.log(query)

    this.ds.query(query, (data) => { 
      if (data.companiesCreatedAt) {
        this.companyDetailsBySourceByDateRange = data.companiesCreatedAt.map((company) => {
          if (company.defaultContact) {
            company.fullName = company.defaultContact.fullName
            company.email = company.defaultContact.email
            company.phone = company.defaultContact.phone
          } else {
            company.fullName = 'unassigned'
            company.email = 'n/a'
            company.phone = 'n/a'
          }

          if (company.user) {
            company.userFullName = company.user.firstName + ' ' + company.user.lastName
          } else {
            company.userFullName = ''
          }

          if (company.vendor) {
            company.vendorName = company.vendor.name
          } else {
            company.vendorName = 'unassigned'
          }

          if (company.source) {
            company.sourceName = company.source.name
          } else {
            company.sourceName = 'unassigned'
          }

          if (company.defaultBillingAddress) {
            company.address = company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.city + ' ' + company.defaultBillingAddress.state + ' ' + company.defaultBillingAddress.zipCode
          } else {
            company.address = 'n/a'
          }

          return company
        })
      }
      
      if (callback) {
        callback(this.companyDetailsBySourceByDateRange)
      }
    })
  }

  @action countNewlyAssignedLeads() {
    let query = `{ countNewlyAssignedCompanies( userId: ${localStorage.getItem('userId')}, hash: "${localStorage.getItem('userHash')}", newAssigned: 1 ) }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.newlyAssignedLeadsCount = data.countNewlyAssignedCompanies
      console.log('Newly Assigned Lead Count: ', this.newlyAssignedLeadsCount)
      return this.newlyAssignedLeadsCount
    })
  }

  @action loadCompanyInvoices(companyId, callback) {
    const query = `{
      quotes(
        companyId: ${ companyId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        company {
          id
          name
          defaultContactId
          stripeCustomerId
        }
        createdAt
        hardwareTotal
        id
        note
        oneTimeTotal
        paymentId
        payment {
          amount
          approvalCode
          cardNumber
          cardType
          createdAt
          paymentTypeId
          qbPaymentNumber          
        }
        qbOrderNumber
        quoteType
        serialNumbers
        taxTotal
        token
        trackingNumber
        userId
        user {
          firstName
          lastName
        } 
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {

      let totalUnpaid = 0;
      
      if (res && res.quotes && res.quotes.length > 0) {

        this.invoices = res.quotes.map((i) => {
          i.agreementName = ''
          i.approvalCode = ''
          i.backendName = ''
          i.billingAddressName = ''
          i.billingZipCode = ''
          i.cardNumber = ''
          i.cardType = ''
          i.carrierName = ''
          i.companyDefaultContactId = 0
          i.companyId = 0
          i.companyName = ''
          i.contractTermName = ''
          i.demoName = (i.demo == 1 ? 'X' : '')
          i.formattedPaymentDate = ''
          i.formattedQuoteDate = ''
          i.leaseName = (i.lease == 1 ? 'X' : '')
          i.paymentTypeId = 0
          i.paymentAmount = 0.00
          i.paymentIntervalName = ''
          i.qbPaymentNumber = ''
          i.serviceName = ''
          i.shippingAddressName = ''
          i.shippingZipCode = ''
          i.shippingTypeName = ''
          i.stripeCustomerId = ''
          i.userFirstName = ''
          i.userLastName = ''
          i.userFullName = '' 
          i.balanceDue = ''
          
          if (i.agreement) {
            i.agreementName = i.agreement.name
          }

          if (i.backend) {
            i.backendName = i.backend.name
          }

          if (i.billingAddress) {
            i.billingAddressName = i.billingAddress.name
            i.billingZipCode = i.billingAddress.zipCode
          }

          if (i.carrier) {
            i.carrierName = i.carrier.name
          }

          if (i.company) {
            i.companyId = i.company.id
            i.companyDefaultContactId = i.company.defaultContactId
            i.companyName = i.company.name
            i.stripeCustomerId = i.company.stripeCustomerId
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.contractTerm) {
            i.contractTermName = i.contractTerm.terms
          }

          if (i.payment) {
            i.qbPaymentNumber = i.payment.qbPaymentNumber
            i.paymentTypeId = i.payment.paymentTypeId
            i.paymentAmount = i.payment.amount
            i.approvalCode = i.payment.approvalCode
            i.cardNumber = i.payment.cardNumber
            i.cardType = i.payment.cardType

            let dd = new Date(i.payment.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedPaymentDate = dateString
          }

          if (i.paymentInterval) {
            i.paymentIntervalName = i.paymentInterval.name
          }

          if (i.service) {
            i.serviceName = i.service.name
          }

          if (i.shippingAddress) {
            i.shippingAddressName = i.shippingAddress.name
            i.shippingZipCode = i.shippingAddress.zipCode
          }

          if (i.shippingType) {
            i.shippingTypeName = i.shippingType.name
          }

          if (i.user) {
            i.userFirstName = i.user.firstName
            i.userLastName = i.user.lastName
            i.userFullName = i.user.firstName + ' ' + i.user.lastName
          }
          
          i.balanceDue = i.oneTimeTotal - i.paymentAmount

          if (i.balanceDue > 0) {
            totalUnpaid = totalUnpaid + i.balanceDue;
          }

          return i
        })

        this.invoices.totalUnpaid = totalUnpaid;

        if (callback) {
          callback(this.invoices)
        }
      } else {
        this.invoices = []
        if (callback) callback(this.invoices)
      }
    })
  }

  /*
  @action loadCompanyInvoices(companyId, callback) {
    const query = `{
      quotes(
        companyId: ${ companyId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        activation
        activationWaived
        agreementId
        agreement {
          name
        }
        backendId
        backend {
          name
        }
        billingAddressId
        billingAddress {
          name
          zipCode
        }
        carrierId
        carrier {
          name
        }
        closeDate
        closePercentage
        company {
          id
          name
          defaultContactId
          stripeCustomerId
        }
        contractTermId
        contractTerm {
          terms
        }
        createdAt
        demo
        featureTotal
        hardwareTotal
        id
        lease
        monthlyTotal
        note
        oneTimeTotal
        paymentId
        payment {
          amount
          approvalCode
          cardNumber
          cardType
          createdAt
          paymentTypeId
          qbPaymentNumber          
        }
        paymentIntervalId
        paymentInterval {
          name
        }
        qbOrderNumber
        quoteType
        serviceId
        service {
          name
        }
        serialNumbers
        serviceTotal
        shippingAddressId
        shippingAddress {
          name
          zipCode
        }
        shippingCost
        shippingTypeId
        shippingType {
          name
        }
        taxTotal
        token
        trackingNumber
        userId
        user {
          firstName
          lastName
        } 
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res.quotes.length > 0) {

        this.invoices = res.quotes.map((i) => {
          i.agreementName = ''
          i.approvalCode = ''
          i.backendName = ''
          i.billingAddressName = ''
          i.billingZipCode = ''
          i.cardNumber = ''
          i.cardType = ''
          i.carrierName = ''
          i.companyDefaultContactId = 0
          i.companyId = 0
          i.companyName = ''
          i.contractTermName = ''
          i.demoName = (i.demo == 1 ? 'X' : '')
          i.formattedPaymentDate = ''
          i.formattedQuoteDate = ''
          i.leaseName = (i.lease == 1 ? 'X' : '')
          i.paymentTypeId = 0
          i.paymentAmount = 0.00
          i.paymentIntervalName = ''
          i.qbPaymentNumber = ''
          i.serviceName = ''
          i.shippingAddressName = ''
          i.shippingZipCode = ''
          i.shippingTypeName = ''
          i.stripeCustomerId = ''
          i.userFirstName = ''
          i.userLastName = ''
          i.userFullName = '' 
          
          if (i.agreement) {
            i.agreementName = i.agreement.name
          }

          if (i.backend) {
            i.backendName = i.backend.name
          }

          if (i.billingAddress) {
            i.billingAddressName = i.billingAddress.name
            i.billingZipCode = i.billingAddress.zipCode
          }

          if (i.carrier) {
            i.carrierName = i.carrier.name
          }

          if (i.company) {
            i.companyId = i.company.id
            i.companyDefaultContactId = i.company.defaultContactId
            i.companyName = i.company.name
            i.stripeCustomerId = i.company.stripeCustomerId
          }

          if (i.createdAt) {
            let dd = new Date(i.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedQuoteDate = dateString
          }

          if (i.contractTerm) {
            i.contractTermName = i.contractTerm.terms
          }

          if (i.payment) {
            i.qbPaymentNumber = i.payment.qbPaymentNumber
            i.paymentTypeId = i.payment.paymentTypeId
            i.paymentAmount = i.payment.amount
            i.approvalCode = i.payment.approvalCode
            i.cardNumber = i.payment.cardNumber
            i.cardType = i.payment.cardType

            let dd = new Date(i.payment.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            i.formattedPaymentDate = dateString
          }

          if (i.paymentInterval) {
            i.paymentIntervalName = i.paymentInterval.name
          }

          if (i.service) {
            i.serviceName = i.service.name
          }

          if (i.shippingAddress) {
            i.shippingAddressName = i.shippingAddress.name
            i.shippingZipCode = i.shippingAddress.zipCode
          }

          if (i.shippingType) {
            i.shippingTypeName = i.shippingType.name
          }

          if (i.user) {
            i.userFirstName = i.user.firstName
            i.userLastName = i.user.lastName
            i.userFullName = i.user.firstName + ' ' + i.user.lastName
          }         

          return i
        })

        if (callback) {
          callback(this.invoices)
        }
      }
    })
  }
  */

  @action loadCompanyQuotes(companyId, callback) {
    this.quotes = []

    const query = `{
      quotes(
        companyId: ${ companyId},
        status: 1,
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        quoteType
        token
        userId
        user {
          firstName
          lastName
        }
        company {
          defaultContactId
          stripeCustomerId
        }
        demo
        lease
        backendId
        backend {
          name
        }
        serviceId
        service {
          name
        }
        carrierId
        carrier {
          name
        }
        paymentIntervalId
        paymentInterval {
          name
        }
        activation
        activationWaived
        serialNumbers
        shippingTypeId
        shippingType {
          name
        }
        shippingCost
        shippingAddressId
        shippingAddress {
          name
          zipCode
        }
        billingAddressId
        billingAddress {
          name
          zipCode
        }
        contractTermId
        contractTerm {
          terms
        }
        closeDate
        closePercentage
        note
        agreementId
        agreement {
          name
        }
        hardwareTotal
        accessoriesTotal
        taxTotal
        oneTimeTotal
        serviceTotal
        featureTotal
        monthlyTotal
        createdAt
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (res && res.quotes && res.quotes.length > 0) {

        this.quotes = res.quotes.map((q) => {
          q.demoName = (q.demo == 1 ? 'X' : '')

          q.leaseName = (q.lease == 1 ? 'X' : '')

          if (q.user) {
            q.userFirstName = q.user.firstName
            q.userLastName = q.user.lastName
            q.userFullName = q.user.firstName + ' ' + q.user.lastName
          }

          if (q.company) {
            q.companyDefaultContactId = q.company.defaultContactId
            q.stripeCustomerId = q.company.stripeCustomerId
          }

          if (q.backend) {
            q.backendName = q.backend.name
          }

          if (q.service) {
            q.serviceName = q.service.name
          }

          if (q.paymentInterval) {
            q.paymentIntervalName = q.paymentInterval.name
          }

          if (q.carrier) {
            q.carrierName = q.carrier.name
          }

          if (q.shippingType) {
            q.shippingTypeName = q.shippingType.name
          }

          if (q.contractTerm) {
            q.contractTermName = q.contractTerm.terms
          }

          if (q.shippingAddress) {
            q.shippingAddressName = q.shippingAddress.name
            q.shippingZipCode = q.shippingAddress.zipCode
          }

          if (q.billingAddress) {
            q.billingAddressName = q.billingAddress.name
            q.billingZipCode = q.billingAddress.zipCode
          }

          if (q.shippingType) {
            q.shippingTypeName = q.shippingType.name
          }

          if (q.agreement) {
            q.agreementName = q.agreement.name
          }

          if (q.createdAt) {
            let dd = new Date(q.createdAt)
            let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
            q.formattedQuoteDate = dateString
          }

          return q
        })

        if (callback) {
          callback(this.quotes)
        }
      } else {
        this.quotes = []
        if (callback) callback(this.quotes)
      }
    })
  }

  @action loadCompanyOrders(companyId, callback) {
    const query = `{
      orders(
        companyId: ${ companyId},
        status: ${ 1},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        organizationId
        companyId
        company {
          name
        }
        quoteId
        quote {
          quoteType
          demo
          lease
          userId
          user {
            firstName
            lastName
          }
          service {
            name
          }
          carrier {
            name
          }
          paymentInterval {
            name
          }
          contractTerm {
            terms
          }
          hardwareTotal
          accessoriesTotal
          serialNumbers
          taxTotal
          oneTimeTotal
          serviceTotal
          featureTotal
          monthlyTotal
        }
        qbOrderNumber
        paymentId
        payment {
          id
          qbPaymentNumber
          qbOrderNumber
          orderId
          amount
          cardNumber
          cardType
          approvalCode
        }
        shippingTypeId
        trackingNumber
        orderStatus
        createdAt
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.orders = data.orders.map((o) => {
        o.demoName = (o.quote.demo == 1 ? 'X' : '')

        o.leaseName = (o.quote.lease == 1 ? 'X' : '')

        if (o.quote.user) {
          o.userFirstName = o.quote.user.firstName
          o.userLastName = o.quote.user.lastName
          o.userFullName = o.quote.user.firstName + ' ' + o.quote.user.lastName
        }

        if (o.quote.quoteType) {
          o.quoteType = o.quote.quoteType
        }

        if (o.quote.backend) {
          o.backendName = o.quote.backend.name
        }

        if (o.quote.updateInterval) {
          o.updateIntervalName = o.quote.updateInterval.name
        }

        if (o.quote.paymentInterval) {
          o.paymentIntervalName = o.quote.paymentInterval.name
        }

        if (o.quote.carrier) {
          o.carrierName = o.quote.carrier.name
        }

        if (o.quote.shippingType) {
          o.shippingTypeName = o.quote.shippingType.name
        }

        if (o.quote.contractTerm) {
          o.contractTermName = o.quote.contractTerm.terms
        }

        if (o.quote.shippingAddress) {
          o.shippingAddressName = o.quote.shippingAddress.name
          o.shippingZipCode = o.quote.shippingAddress.zipCode
        }

        if (o.quote.billingAddress) {
          o.billingAddressName = o.quote.billingAddress.name
          o.billingZipCode = o.quote.billingAddress.zipCode
        }

        if (o.quote.shippingType) {
          o.shippingTypeName = o.quote.shippingType.name
        }

        if (o.quote.agreement) {
          o.agreementName = o.quote.agreement.name
        }

        if (o.quote.oneTimeTotal) {
          o.oneTimeTotal = o.quote.oneTimeTotal
        }

        if (o.quote.monthlyTotal) {
          o.monthlyTotal = o.quote.monthlyTotal
        }

        if (o.quote.serialNumbers) {
          o.serialNumbers = o.quote.serialNumbers
        }

        if (o.createdAt) {
          let dd = new Date(o.createdAt)
          let dateString = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
          o.formattedOrderDate = dateString
        }

        o.balance = 0
        o.paymentAmount = 0

        if (o.payment) {
          o.qbOrderNumber = o.payment.qbOrderNumber
          o.qbPaymentNumber = o.payment.qbPaymentNumber
          o.paymentAmount = o.payment.amount
          o.approvalCode = o.payment.approvalCode
          o.cardNumber = o.payment.cardNumber
          o.cardType = o.payment.cardType
          o.balance = o.oneTimeTotal - o.paymentAmount
        } else {
          o.balance = o.oneTimeTotal
        }

        return o
      })

      if (callback) {
        callback(data.orders)
      }
    })
  }

  @action deleteOrder(id, callback) {
    let query = `mutation {
      deleteOrder(
        id: ${ id},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    this.ds.query(query, (data) => {
      if (callback) {
        callback()
      }
    })
  }

  @action setDefaultBillingAddressId(id, addressId, callback) {
    let query = `mutation { setDefaultBillingAddressId(id: ${id}, defaultBillingAddressId: ${addressId}, hash: "${localStorage.getItem('userHash')}") { id } }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.loadCompanyDetails({ id: id })

      if (callback) {
        return callback()
      }
    })
  }

  @action setDefaultShippingAddressId(id, addressId, callback) {
    let query = `mutation { setDefaultShippingAddressId(id: ${id}, defaultShippingAddressId: ${addressId}, hash: "${localStorage.getItem('userHash')}") { id } }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.loadCompanyDetails({ id: id })

      if (callback) {
        return callback()
      }
    })
  }

  @action loadAllCompanies(callback) {
    let query = `{ companies(hash: "${localStorage.getItem('userHash')}") { id name vendorId vendor { name } } }`
    console.log(query)
    this.ds.query(query, (data) => {
      this.data = data.companies.map((c) => {

        if (c.vendor != null) {
          c.vendorName = c.vendor.name
        } else {
          c.vendorName = ''
        }

        return c
      })

      //this.data = data.companies

      if (callback != null) {
        return callback(this.data)
      }
    })
  }

  @action loadNewlyAssignedCompanies(callback) {
    let query = `{ companies(userId: ${localStorage.getItem('userId')}, hash: "${localStorage.getItem('userHash')}", newAssigned: 1) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source{ name }} }`

    console.log(query)
    this.ds.query(query, (data) => {
      if (data.companies) {
        this.assigned = data.companies.map((company) => {
          if (company.defaultContact) {
            company.fullName = company.defaultContact.fullName
            company.email = company.defaultContact.email
            company.phone = company.defaultContact.phone
          } else {
            company.fullName = 'unassigned'
            company.email = 'n/a'
            company.phone = 'n/a'
          }

          if (company.user) {
            company.userFullName = company.user.firstName + ' ' + company.user.lastName
          } else {
            company.userFullName = ''
          }

          if (company.vendor) {
            company.vendorName = company.vendor.name
          } else {
            company.vendorName = 'unassigned'
          }

          if (company.source) {
            company.sourceName = company.source.name
          } else {
            company.sourceName = 'unassigned'
          }

          if (company.defaultBillingAddress) {
            company.address = company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.city + ' ' + company.defaultBillingAddress.state + ' ' + company.defaultBillingAddress.zipCode
          } else {
            company.address = 'n/a'
          }
          //company.companyState = company.companyState.name
          return company
        })
      }

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllCompaniesByCompanyState(companyStateId, callback) {
    let query = ''
    if (localStorage.getItem('userAccessLevel') >= 15) {
      query = `{ companies(hash: "${localStorage.getItem('userHash')}", companyStateId: ${companyStateId}) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source{ name }} }`
    } else {
      query = `{ companies(userId: ${localStorage.getItem('userId')}, hash: "${localStorage.getItem('userHash')}", companyStateId: ${companyStateId}) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source{ name }} }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      if (data.companies) {
        this.companiesByState = data.companies.map((company) => {
          if (company.defaultContact) {
            company.fullName = company.defaultContact.fullName
            company.email = company.defaultContact.email
            company.phone = company.defaultContact.phone
          } else {
            company.fullName = 'unassigned'
            company.email = 'n/a'
            company.phone = 'n/a'
          }

          if (company.user) {
            company.userFullName = company.user.firstName + ' ' + company.user.lastName
          } else {
            company.userFullName = ''
          }

          if (company.vendor) {
            company.vendorName = company.vendor.name
          } else {
            company.vendorName = 'unassigned'
          }

          if (company.source) {
            company.sourceName = company.source.name
          } else {
            company.sourceName = 'unassigned'
          }

          if (company.defaultBillingAddress) {
            company.address = company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.city + ' ' + company.defaultBillingAddress.state + ' ' + company.defaultBillingAddress.zipCode
          } else {
            company.address = 'n/a'
          }
          //company.companyState = company.companyState.name
          return company
        })
      }

      if (callback) {
        return callback()
      }
    })
  }

  @action resetCompaniesByState() {
    this.companiesByState = [];
  }

  @action loadAllLeads(callback) {
    let query = ''
    if (localStorage.getItem('userAccessLevel') >= 15) {
      query = `{ companies(hash: "${localStorage.getItem('userHash')}", companyStateId: 2) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source{ name }} }`
    } else {
      query = `{ companies(userId: ${localStorage.getItem('userId')}, hash: "${localStorage.getItem('userHash')}", companyStateId: 2) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source{ name }} }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      this.leads = []
      this.leads = data.companies.map((company) => {
        if (company.defaultContact) {
          company.fullName = company.defaultContact.fullName
          company.email = company.defaultContact.email
          company.phone = company.defaultContact.phone
        } else {
          company.fullName = 'unassigned'
          company.email = 'n/a'
          company.phone = 'n/a'
        }

        if (company.user) {
          company.userFullName = company.user.firstName + ' ' + company.user.lastName
        } else {
          company.userFullName = ''
        }

        if (company.vendor) {
          company.vendorName = company.vendor.name
        } else {
          company.vendorName = 'unassigned'
        }

        if (company.source) {
          company.sourceName = company.source.name
        } else {
          company.sourceName = 'unassigned'
        }

        if (company.defaultBillingAddress) {
          company.address = company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.city + ' ' + company.defaultBillingAddress.state + ' ' + company.defaultBillingAddress.zipCode
        } else {
          company.address = 'n/a'
        }
        //company.companyState = company.companyState.name
        return company
      })

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllCustomers(callback) {
    let query = ''
    if (localStorage.getItem('userAccessLevel') >= 15) {
      query = `{ companies(hash: "${localStorage.getItem('userHash')}", companyStateId: 3) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source { name }} }`
    } else {
      query = `{ companies(userId: ${localStorage.getItem('userId')}, hash: "${localStorage.getItem('userHash')}", companyStateId: 3) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source { name }} }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      this.customers = []
      this.customers = data.companies.map((company) => {
        if (company.defaultContact) {
          company.fullName = company.defaultContact.fullName
          company.email = company.defaultContact.email
          company.phone = company.defaultContact.phone
        } else {
          company.fullName = 'unassigned'
          company.email = 'n/a'
          company.phone = 'n/a'
        }

        if (company.user) {
          company.userFullName = company.user.firstName + ' ' + company.user.lastName
        } else {
          company.userFullName = ''
        }

        if (company.vendor) {
          company.vendorName = company.vendor.name
        } else {
          company.vendorName = 'unassigned'
        }

        if (company.source) {
          company.sourceName = company.source.name
        } else {
          company.sourceName = 'unassigned'
        }


        if (company.defaultBillingAddress) {
          company.address = company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.city + ' ' + company.defaultBillingAddress.state + ' ' + company.defaultBillingAddress.zipCode
        } else {
          company.address = 'n/a'
        }

        //company.companyState = company.companyState.name

        return company
      })

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllContacts(callback) {
    let query = ''
    if (localStorage.getItem('userAccessLevel') >= 15) {
      query = `{ companies(hash: "${localStorage.getItem('userHash')}", companyStateId: 1) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source { name }} }`
    } else {
      query = `{ companies(userId: ${localStorage.getItem('userId')}, hash: "${localStorage.getItem('userHash')}", companyStateId: 1) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } user { firstName lastName } vendor { name } source { name }} }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      this.contacts = []
      this.contacts = data.companies.map((company) => {
        if (company.defaultContact) {
          company.fullName = company.defaultContact.fullName
          company.email = company.defaultContact.email
          company.phone = company.defaultContact.phone
        } else {
          company.fullName = 'unassigned'
          company.email = 'n/a'
          company.phone = 'n/a'
        }

        if (company.user) {
          company.userFullName = company.user.firstName + ' ' + company.user.lastName
        } else {
          company.userFullName = ''
        }

        if (company.vendor) {
          company.vendorName = company.vendor.name
        } else {
          company.vendorName = 'unassigned'
        }

        if (company.source) {
          company.sourceName = company.source.name
        } else {
          company.sourceName = 'unassigned'
        }

        if (company.defaultBillingAddress) {
          company.address = company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.city + ' ' + company.defaultBillingAddress.state + ' ' + company.defaultBillingAddress.zipCode
        } else {
          company.address = 'n/a'
        }
        //company.companyState = company.companyState.name
        return company
      })

      if (callback != null) {
        callback()
      }
    })
  }

  @action loadAllInactive() {
    let query = ''
    if (localStorage.getItem('userAccessLevel') >= 15) {
      query = `{ companies(hash: "${localStorage.getItem('userHash')}", companyStateId: 4) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } vendor { name } source{ name }} }`
    } else {
      query = `{ companies(userId: ${localStorage.getItem('userId')}, hash: "${localStorage.getItem('userHash')}", companyStateId: 4) { id name defaultContact { fullName email phone } defaultBillingAddress { address city state zipCode } vendor { name } source{ name }} }`
    }

    console.log(query)
    this.ds.query(query, (data) => {
      this.inactive = []
      this.inactive = data.companies.map((company) => {
        if (company.defaultContact) {
          company.fullName = company.defaultContact.fullName
          company.email = company.defaultContact.email
          company.phone = company.defaultContact.phone
        } else {
          company.fullName = 'unassigned'
          company.email = 'n/a'
          company.phone = 'n/a'
        }

        if (company.vendor) {
          company.vendorName = company.vendor.name
        } else {
          company.vendorName = 'unassigned'
        }

        if (company.source) {
          company.sourceName = company.source.name
        } else {
          company.sourceName = 'unassigned'
        }

        if (company.defaultBillingAddress) {
          company.address = company.defaultBillingAddress.address + ' ' + company.defaultBillingAddress.city + ' ' + company.defaultBillingAddress.state + ' ' + company.defaultBillingAddress.zipCode
        } else {
          company.address = 'n/a'
        }
        //company.companyState = company.companyState.name
        return company
      })
    })
  }

  @action newCompany(data, callback) {

    const queryString = `mutation {
      addCompany(
        name: "${ data.name}",
        companyStateId: ${ data.companyStateId},
        organizationId: ${ data.organizationId},
        sourceId: ${ data.sourceId},
        vendorId: ${ data.vendorId},
        salesNote: "${ data.salesNote}",
        title: "${ data.title}",
        firstName: "${ data.firstName}",
        lastName: "${ data.lastName}",
        email: "${ data.email}",
        phone: "${ data.phone}",
        address: "${ data.address}",
        city: "${ data.city}",
        state: "${ data.state}",
        zipCode: "${ data.zipCode}",
        country: "${ data.country}",
        categoryId: ${ data.categoryId},
        userId: ${ data.userId},
        hash: "${ data.hash}"
      ) { id }
    }`

    console.log(queryString)

    this.ds.query(queryString, (res) => {
      //this.loadAllCompanies(data.hash)
      if (callback) {
        callback(res)
      }
    })
  }

  @action loadCompanyDetails(row, callback) {
    let query = `{
      companies(id: ${ row.id}, hash: "${localStorage.getItem('userHash')}") {
        id
        name
        user {
          firstName
          lastName
        }
        userId
        defaultContactId
        defaultContact {
          firstName
          lastName
          fullName
          title
          email
          phone
        }
        categoryId
        category {
          name
          industry {
            name
          }
        }
        companyStateId
        companyState {
          name
        }
        billingStatus {
          name
        }
        defaultBillingAddress {
          name
          address
          city
          state
          zipCode
        }
        defaultShippingAddress {
          name
          address
          city
          state
          zipCode
        }
        defaultShippingAddressId
        defaultBillingAddressId
        freeShipping
        partnerId
        vendorId
        vendor {
          name
        }
        sourceId
        source {
          name
        }
        salesNote
        qbCustomerId
        stripeCustomerId
        qbBillingAddressId
        qbShippingAddressId
        partner {
          firstName
          lastName
        }
        newAssigned
        taxable
      }
    }`

    console.log(query)
    this.ds.query(query, (data) => {
      if (data.companies.length > 0) {
        this.details = data.companies.map((company) => {
          company.userName = ''
          company.contactFirstName = ''
          company.contactLastName = ''
          company.contactFullName = ''
          company.contactTitle = ''
          company.contactEmail = ''
          company.contactPhone = ''
          company.categoryName = ''
          company.industryName = ''
          company.vendorName = ''
          company.userFullName = ''
          company.partnerFullName = ''

          if (company.defaultBillingAddress == null) {
            company.defaultBillingAddress = {
              name: '',
              addresss: '',
              city: '',
              state: '',
              zipCode: ''
            }
          }

          if (company.defaultShippingAddress == null) {
            company.defaultShippingAddress = {
              name: '',
              addresss: '',
              city: '',
              state: '',
              zipCode: ''
            }
          }

          if (company.user) {
            company.userName = company.user.firstName + ' ' + company.user.lastName
          }

          if (company.defaultContact) {
            company.contactFirstName = company.defaultContact.firstName
            company.contactLastName = company.defaultContact.lastName
            company.contactFullName = company.defaultContact.fullName
            company.contactTitle = company.defaultContact.title
            company.contactEmail = company.defaultContact.email
            company.contactPhone = company.defaultContact.phone
          }

          if (company.category) {
            company.categoryName = company.category.name
            //company.industryName = company.category.industry.name
          }
          if (company.vendor) {
            company.vendorName = company.vendor.name
          }

          if (company.source) {
            company.sourceName = company.source.name
          }

          if (company.user) {
            company.userFullName = company.user.firstName + ' ' + company.user.lastName
          }

          if (company.partner) {
            company.partnerFullName = company.partner.firstName + ' ' + company.partner.lastName
          }

          company.companyState = company.companyState.name
          company.billingStatus = company.billingStatus.name
          company.billingAddressName = company.defaultBillingAddress.name
          company.billingAddressAddress = company.defaultBillingAddress.address
          company.billingAddressCity = company.defaultBillingAddress.city
          company.billingAddressState = company.defaultBillingAddress.state
          company.billingAddressZipCode = company.defaultBillingAddress.zipCode
          company.shippingAddressName = company.defaultShippingAddress.name
          company.shippingAddressAddress = company.defaultShippingAddress.address
          company.shippingAddressCity = company.defaultShippingAddress.city
          company.shippingAddressState = company.defaultShippingAddress.state
          company.shippingAddressZipCode = company.defaultShippingAddress.zipCode

          return company
        })[0]

        this.loadCompanyPartner(this.details.partnerId)

        if (callback) {
          callback(this.details)
        }
      }
    })
  }

  @action loadNote(id, callback) {
    let query = `{
      notes(
        id: ${ id},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        note
        userId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      if (data.notes.length > 0) {
        this.noteDetail = data.notes[0]
        callback(data.notes[0])
      }
    })
  }

  @action loadCompanyNotes(id, callback) {
    let query = `{
      notes(
        companyId: ${ id},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        note
        createdAt
        user {
          firstName
          lastName
        }
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.notes = data.notes.map((note) => {
        note.userFullName = note.user.firstName + ' ' + note.user.lastName
        let cd = new Date(note.createdAt)
        note.formattedCreatedDate = ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        return note
      })

      if (callback) {
        return callback()
      }
    })
  }

  @action loadTask(id, callback) {
    let query = `{
      tasks(
        id: ${ id},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        userId
        assignedUserId
        assignedUser {
          firstName
          lastName
        }
        task
        dueDate
        taskPriorityId
        taskPriority {
          name
        }
        taskStateId
        taskState {
          name
        }
        company {
          defaultContact{
            email
            phone
          }
        }
      }
    }`
    console.log(query)
    this.ds.query(query, (data) => {
      if (data.tasks.length > 0) {
        let task = data.tasks[0]

        if (task.assignedUser != null) {
          task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName
        } else {
          task.assignedUserName = ''
        }


        this.taskDetail = task
        callback(task)
      } else {
        console.log('Nothing from query')
      }
    })
  }

  @action loadCompanyTasks(id, callback) {
    let query = `{
      tasks(
        companyId: ${ id},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        task
        dueDate
        company {
          name
          defaultBillingAddress {
            city
            state
          }
        }
        taskPriority {
          name
        }
        taskState {
          name
        }
        user {
          firstName
          lastName
        }
        assignedUserId
        assignedUser {
          firstName
          lastName
        }
        createdAt
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.tasks = data.tasks.map((task) => {
        //Set default values
        task.companyName = ''
        task.fullAddress = 'N/A'
        task.assignedUserName = ''

        let dd = new Date(task.dueDate)
        task.formattedDueDate = ('0' + (dd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (dd.getUTCDate())).slice(-2) + '-' + dd.getUTCFullYear()
        
        let cd = new Date(task.createdAt)
        task.formattedCreatedDate = ('0' + (cd.getUTCMonth() + 1)).slice(-2) + '-' + ('0' + (cd.getUTCDate())).slice(-2) + '-' + cd.getUTCFullYear()
        
        if (task.company != null) {
          //task.fullAddress = task.company.defaultBillingAddress.city + ', ' + task.company.defaultBillingAddress.state
          task.companyName = task.company.name
          if (task.company.defaultBillingAddress != null) {
            task.fullAddress = task.company.defaultBillingAddress.city + ', ' + task.company.defaultBillingAddress.state
          }
        }

        if (task.assignedUser != null) {
          task.assignedUserName = task.assignedUser.firstName + ' ' + task.assignedUser.lastName
        }
        
        task.userFullName = task.user.firstName + ' ' + task.user.lastName
        task.priority = task.taskPriority.name
        task.state = task.taskState.name
        return task
      })

      if (callback) {
        return callback()
      }
    })
  }

  @action loadCompanyPartner(id) {
    let query = `{
      partners(id: ${ id}, hash: "${localStorage.getItem('userHash')}") {
        id
        firstName
        lastName
        address
        city
        state
        zipCode
        partnerCode
        partnerType {
          name
          partnerCompany {
            name
          }
        }
      }
    }`

    this.ds.query(query, (data) => {
      if (data.partners.length > 0) {
        this.partners = data.partners[0]
      }
    })
  }

  @action updateCompany(data, callback) {
    data.partnerId = data.partnerId == '' ? 0 : data.partnerId
    data.categoryId = data.categoryId == '' ? 0 : data.categoryId

    let query = `mutation {
      updateCompany(
        id: ${ data.id},
        userId: ${ data.userId},
        newAssigned: ${ data.newAssigned},
        name: "${ data.name}",
        categoryId: ${ data.categoryId},
        vendorId: ${ data.vendorId},
        sourceId: ${ data.sourceId},
        companyStateId: ${ data.companyStateId},
        partnerId: ${ data.partnerId},
        salesNote: "${ data.salesNote}",
        taxable: ${ data.taxable ? data.taxable : 0},
        hash: "${ data.hash}"
      ) {
        id
        defaultContactId
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      this.loadCompanyDetails({ id: data.id, hash: data.hash }, (res) => {
        if (callback) {
          callback(res)
        }
      })
    })

    /*
    this.ds.query(query, (res) => {
      let query = `mutation {
        updateContact(
          id: ${ res.updateCompany.defaultContactId},
          title: "${ data.title}",
          firstName: "${ data.firstName}",
          lastName: "${ data.lastName}",
          email: "${ data.email}",
          phone: "${ data.phone}",
          hash: "${ data.hash}"
        ) {
          id
        }
      }`

      console.log(query)

      this.ds.query(query, (res) => {
        this.loadCompanyDetails({ id: data.id, hash: data.hash }, (res) => {
          if (callback) {
            callback(res)
          }
        })
      })
    })
    */
  }

  @action updateFreeShippingStatus(data, callback) {
    let query = `mutation {
      updateFreeShippingStatus(
        id: ${ data.id },
        freeShipping: ${ data.freeShipping },
        hash: "${ localStorage.getItem('userHash') }"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res)   
      }
    })
  }

  @action updateAssignedUser(data, callback) {

    let query = `mutation {
      updateCompany(
        id: ${ data.id},
        userId: ${ data.userId},
        newAssigned: 1,
        hash: "${ data.hash}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res)
      }
    })
  }

  @action deleteCompany(row, callback) {
    let query = `mutation {
      deleteCompany(
        id: ${ row.id},
        hash: "${ row.hash}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      //this.loadAllCompanies(row.hash)
      if (callback) {
        callback()
      }
    })
  }

  @action selectRep(id) {
    document.getElementById('repId').value = id
  }

  @action selectCompanyState(id) {
    document.getElementById('companyStateId').value = id
  }

  @action selectCategory(id) {
    document.getElementById('categoryId').value = id
  }

  @action selectPartner(id) {
    document.getElementById('partnerId').value = id
  }

  /**
   * Notes
   **/
  @action addNote(row, callback) {
    let query = `mutation {
      addNote(
        note: "${ row.note}",
        companyId: ${ row.companyId},
        userId: ${ row.userId},
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        companyId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadCompanyNotes(data.addNote.companyId, row.hash)

      if (callback) {
        callback(data)
      }
    })
  }

  @action updateNote(row, callback) {
    const query = `mutation {
      updateNote(
        id: ${ row.id},
        note: "${ row.note}",
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
        companyId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadCompanyNotes(data.updateNote.companyId, row.hash)
      if (callback) {
        callback(data)
      }
    })
  }

  @action emailNote(params, callback) {
    const query = `mutation {
      emailNote(
        id: ${ params.noteId },
        emailAddress: "${ params.emailAddress }",
        userId: ${ localStorage.getItem('userId') }
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (res) => {
      if (callback) {
        callback(res)
      }
    })
  }

  @action deleteNote(id, companyId, hash) {
    this.ds.query(`mutation {
      deleteNote(
        id: ${ id},
        hash: "${ hash}"
      ) { id }
    }`, (data) => {
        this.loadCompanyNotes(companyId, hash)
      })
  }

  /**
   * tasks
   **/
  @action addTask(row, callback) {
    this.ds.query(`mutation {
      addTask(
        companyId: ${ row.companyId},
        userId: ${ row.userId},
        assignedUserId: ${ row.assignedUserId},
        newAssigned: ${ row.newAssigned},
        taskPriorityId: ${ row.taskPriorityId},
        dueDate: "${ row.dueDate}",
        task: "${ row.task}",
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`, (data) => {
        this.loadCompanyTasks(row.companyId)

        if (callback) {
          callback(data)
        }
      })
  }

  @action updateTask(row, callback) {
    let query = `mutation {
      updateTask(
        id: ${ row.id},
        assignedUserId: ${ row.assignedUserId},
        newAssigned: ${ row.newAssigned},
        taskPriorityId: ${ row.taskPriorityId},
        taskStateId: ${ row.taskStateId},
        dueDate: "${ row.dueDate}",
        task: "${ row.task}",
        hash: "${ localStorage.getItem('userHash')}"
      ) {
        id
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.loadCompanyTasks(row.companyId)

      if (callback) {
        callback(data)
      }
    })
  }

  @action getStripeCustomerId(id, callback) {
    let query = `{
      companies(id: ${id}, hash: "${localStorage.getItem('userHash')}") {
        id
        stripeCustomerId
      }
    }`

    console.log(query)

    this.ds.query(query, (data) => {
      this.stripeCustomerId = data.companies[0].stripeCustomerId

      if (callback) {
        return callback(this.stripeCustomerId)
      }
    })
  }

  @action resetSources() {
    console.log('Resetting sources...')
    this.sources = []
  }

  @action getStripeSourcesByStripeCustomerId(stripeCustomerId, callback) {
    let query = `{
      getStripeSourcesByStripeCustomerId(
        stripeCustomerId: "${stripeCustomerId}"
      ) {
        statusCode
        data 
      }
    }`
    
    console.log(query)
    this.ds.query(query, (data) => { 
      if (data.getStripeSourcesByStripeCustomerId.data.results.sources.data) {
        this.sources = data.getStripeSourcesByStripeCustomerId.data.results.sources.data.map((sources) => {
          //Set Defaults
          sources.dateCreated = '01/01/2015';

          if (sources.metadata.dateCreated) {
            sources.dateCreated = moment.unix(sources.metadata.dateCreated).format('MM/DD/YYYY')
          }
          return sources
        })
      }
      
      if (callback) {
        callback(this.sources)
      }
    })

    /*
      this.sources = data.getStripeSourcesByStripeCustomerId.data.results.sources.data

      if (callback) {
        return callback(data)
      }
    })
    */
  }

  @action saveNewCreditCard(params, callback) {
    const query = `{ stripeSaveNewCreditCard(
      companyId: ${ params.companyId },
      stripeCustomerId: "${ params.stripeCustomerId }",
      stripeToken: "${ params.stripeToken }",
      organizationId: ${ localStorage.getItem('userOrganizationId') },
      dateCreated: ${ params.dateCreated },
      hash: "${ localStorage.getItem('userHash') }"
    ) { statusCode data } }`

    console.log(query)

    this.ds.query(query, (data) => {
      console.log('Results: ', data)
      this.saveCardResults = data.stripeSaveNewCreditCard

      if (callback) {
        return callback()
      }
    })
  }

  @action deleteSavedCard(params, callback) {
    const query = `{ stripeDeleteCreditCard(
      stripeCustomerId: "${ params.stripeCustomerId }",
      stripeCardId: "${ params.stripeCardId }",
      organizationId: ${ localStorage.getItem('userOrganizationId') },
      hash: "${ localStorage.getItem('userHash') }"
    ) { statusCode data } }`

    console.log(query)

    this.ds.query(query, (data) => {
      console.log('Results: ', data)
      this.saveCardResults = data.stripeDeleteCreditCard

      if (callback) {
        return callback()
      }
    })
  }
}

export default new Companies()



// WEBPACK FOOTER //
// ./src/stores/companies.js